import React, { useEffect, useState } from 'react'
import style from './ganttChart.module.scss'
import { gantt } from 'dhtmlx-gantt'
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css'
import { useAppSelector } from '../../starter/hooks/redux'
import './gantCustomStyle.css'

type TGantChart = {
  tasks: any
  zoom: any
}
const GanttChart = ({ tasks, zoom }: TGantChart) => {
  const { type } = useAppSelector((state) => state.gantt)
  const [ganttContainer, setGanttContainer] = useState<HTMLDivElement | string>('')
  const { period } = useAppSelector((state) => state.gantt)

  useEffect(() => {
    gantt.config.readonly = true
    gantt.config.date_format = '%Y-%m-%d %H:%i'
    gantt.config.grid_width = 400
    gantt.config.columns = [
      {
        name: 'text',
        label: type === 'employee' ? 'Сотрудники / Проекты' : 'Проекты / Сотрудники',
        tree: true,
        width: '200'
      },
      { name: 'start_date', label: 'Начало', align: 'center', width: '*' },
      { name: 'end_date', label: 'Конец', align: 'center', width: '*' },
      { name: 'duration', label: 'Duration', align: 'center', hide: true },
      { name: 'add', label: '', hide: true }
    ]
    gantt.config.start_date = period.start
    gantt.config.end_date = period.end
    gantt.config.resource_render_empty_cells = true
    // @ts-ignore
    gantt.templates.grid_row_class = function (start_date, end_date, item) {
      if (item.isForgotten) return 'isForgotten'
    }

    // @ts-ignore
    gantt.templates.task_row_class = function (start_date, end_date, item) {
      if (item.isForgotten) return 'isForgotten'
    }

    //устанавливаем локаль
    gantt.i18n.setLocale({
      date: {
        month_full: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь'
        ],
        month_short: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        day_full: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        day_short: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
      },
      labels: {
        new_task: 'New task',
        icon_save: 'Save',
        icon_cancel: 'Cancel',
        icon_details: 'Details',
        icon_edit: 'Edit',
        icon_delete: 'Delete',
        gantt_save_btn: 'New Label',
        gantt_cancel_btn: 'New Label',
        gantt_delete_btn: 'New Label',
        confirm_closing: '', // Your changes will be lost, are you sure?
        confirm_deleting: 'Task will be deleted permanently, are you sure?',
        section_description: 'Description',
        section_time: 'Time period',
        section_type: 'Type',

        /* grid columns */
        column_wbs: 'WBS',
        column_text: 'Task name',
        column_start_date: 'Start time',
        column_duration: 'Duration',
        column_add: '',

        /* link confirmation */
        link: 'Link',
        confirm_link_deleting: 'will be deleted',
        link_start: ' (start)',
        link_end: ' (end)',

        type_task: 'Task',
        type_project: 'Project',
        type_milestone: 'Milestone',

        minutes: 'Minutes',
        hours: 'Hours',
        days: 'Days',
        weeks: 'Week',
        months: 'Months',
        years: 'Years',

        /* message popup */
        message_ok: 'OK',
        message_cancel: 'Cancel',

        /* constraints */
        section_constraint: 'Constraint',
        constraint_type: 'Constraint type',
        constraint_date: 'Constraint date',
        asap: 'As Soon As Possible',
        alap: 'As Late As Possible',
        snet: 'Start No Earlier Than',
        snlt: 'Start No Later Than',
        fnet: 'Finish No Earlier Than',
        fnlt: 'Finish No Later Than',
        mso: 'Must Start On',
        mfo: 'Must Finish On',

        /* resource control */
        resources_filter_placeholder: 'type to filter',
        resources_filter_label: 'hide empty'
      }
    })
    gantt.init(ganttContainer)
    // gantt.parse(tasks)
  }, [tasks, type, period])

  useEffect(() => {
    if (!gantt.$initialized) {
      initZoom()
    }
    gantt.ext.zoom.setLevel(zoom)
    gantt.render()
  }, [zoom])

  useEffect(() => {
    gantt.clearAll()
    gantt.parse(tasks)
  }, [tasks])

  useEffect(() => {
    gantt.config.open_split_tasks = type === 'employee'
  }, [type])
  const initZoom = () => {
    gantt.ext.zoom.init({
      levels: [
        {
          name: 'Hours',
          scale_height: 60,
          min_column_width: 30,
          scales: [
            { unit: 'day', step: 1, format: '%d %M' },
            { unit: 'hour', step: 1, format: '%H' }
          ]
        },
        {
          name: 'Days',
          scale_height: 60,
          min_column_width: 50,
          scales: [
            { unit: 'week', step: 1, format: 'Week #%W' },
            { unit: 'day', step: 1, format: '%d %M' }
          ]
        },
        {
          name: 'Months',
          scale_height: 60,
          min_column_width: 25,
          scales: [
            { unit: 'month', step: 1, format: '%F' },
            { unit: 'week', step: 1, format: '#%W' }
          ]
        }
      ]
    })
  }
  return (
    <div
      className={style.wrapper}
      ref={(input: HTMLDivElement) => {
        setGanttContainer(input)
      }}></div>
  )
}

export default GanttChart
